import { format, parseISO, isValid } from 'date-fns';

/**
 * Safely format an ISO date string. Returns fallback on invalid/missing input
 * instead of throwing (which would crash the React component tree).
 */
export function safeFormatDate(isoString: string | null | undefined, formatStr: string, fallback = '-'): string {
  if (!isoString) return fallback;
  try {
    const date = parseISO(isoString);
    if (!isValid(date)) {
      console.warn('[safeFormatDate] Invalid date value:', isoString);
      return fallback;
    }
    return format(date, formatStr);
  } catch (err) {
    console.warn('[safeFormatDate] Date formatting failed:', isoString, err);
    return fallback;
  }
}

/**
 * Format integer minutes into a human-readable duration string.
 */
export function formatMinutes(minutes: number): string {
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
}
